<div
  class="ui label warning-label"
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  "
  *ngIf="message"
>
  <div>{{ message }}</div>
  <button
    *ngIf="redirect_url"
    style="margin-top: 15px"
    class="ui primary button"
  >
    <a (click)="redirectToExternalUrl()" style="color: white">
      Go back to {{ applicationType }} application
    </a>
  </button>
</div>
<div class="heading" fxLayout="row" fxLayoutAlign="space-between center">
  <!-- <h3 appMargin marginB="0" class="ui primary header">{{affiliateTypeName | titlecase | plural}}</h3> -->
  <h3 appMargin marginB="0" class="ui primary header">
    {{ affiliateTypeName | titlecase }}s
  </h3>
  <div>
    <label
      *ngIf="
        directorStatus != 'NOT_AVAILABLE' &&
        ((!isEdit && directorStatus) || (isPending && directorStatus))
      "
      class="ui tiny circular label"
      [ngClass]="{
        'label-green': directorStatus == 'VERIFIED',
        'label-grey': directorStatus == 'NOT_AVAILABLE',
        'label-red':
          directorStatus == 'REJECTED' || directorStatus == 'UNVERIFIED',
        'label-orange': directorStatus == 'PENDING'
      }"
      >{{
        directorStatus == "NOT_AVAILABLE"
          ? ""
          : (directorStatus | uppercase | removeUnderscore)
      }}</label
    >
    <ng-container *ngIf="!isEdit && !isPending">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="viewHistory()"
        class="ui tiny basic primary button"
        style="margin: 0px 10px"
      >
        View History
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="updateDirector()"
        class="ui tiny primary button"
      >
        Make Updates
      </button></ng-container
    >

    <ng-container *ngIf="isEdit">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="addDirector()"
        class="ui tiny basic primary button"
        style="margin: 0px 10px"
      >
        {{
          typeStructure === "SHAREHOLDER_STRUCTURE"
            ? "Add New Shareholder"
            : "Add New Individual"
        }}
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="cancelUpdate()"
        class="ui tiny basic primary button"
        style="margin: 0px 10px"
      >
        Cancel Update
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="saveDirector()"
        [disabled]="checkDisabled()"
        class="ui tiny primary button"
      >
        Save
      </button>
    </ng-container>
    <ng-container *ngIf="!isEdit && isPending">
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="viewHistory()"
        class="ui tiny basic primary button"
        style="margin: 0px 10px"
      >
        View Pending Updates
      </button>
      <button
        *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
        (click)="updateDirector()"
        class="ui tiny primary button"
      >
        Make Updates
      </button>
    </ng-container>
  </div>
</div>
<hr />
<div
  class="ui label warning-label"
  *ngIf="directorStatus == 'PENDING' && !isEdit"
>
  Your changes are pending and will be verified in due time. However, you can
  send us a chat message
  <a style="font-weight: 900; color: #3f4395" [routerLink]="chatLink">here</a>
  if you have any question or feedback.
</div>
<div
  class="ui label information-label"
  *ngIf="typeStructure === 'SHAREHOLDER_STRUCTURE' && isEdit"
>
  Information for each Shareholder must be complete and accurate. Add, remove,
  or modify each shareholder, one after the other, then click on Save. Total
  Shareholding for all Shareholders must be 100% for information to be saved
  successfully.
</div>

<div
  class="ui label warning-label label-green"
  *ngIf="directorStatus == 'VERIFIED' && !isEdit"
>
  Your {{ affiliateTypeName | titlecase }} structure information has been
  verified.
</div>

<app-search-filter
  [filter]="filter"
  (onSearch)="searchRecords($event)"
  (onDisplayRows)="displayRecords($event)"
  (onSort)="sortRecords($event)"
></app-search-filter>
<div class="ui vertical basic segment" *ngIf="success || error">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<!-- </div> -->
<div
  fxLayout="row"
  style="align-items: center !important"
  appMargin
  class="ui segment"
  marginB="3"
  fxLayoutGap="10px"
  id="dark"
>
  <div fxFlex="5%" *ngIf="isEdit"></div>
  <div fxFlex="7%"></div>
  <div fxFlex="15%">FIRST NAME</div>
  <div fxFlex="15%">LAST NAME</div>
  <div fxFlex="15%">DATE ADDED</div>
  <div fxFlex="10%">ADDED BY</div>
  <div *ngIf="affiliateTypeId === 'shareholder_type'" fxFlex="13%">
    SHAREHOLDER TYPE
  </div>
  <div *ngIf="affiliateTypeId === 'shareholder_type'" fxFlex="7%">SHARES</div>
  <div fxFlex="10%"></div>
</div>
<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending || pendingArr.length }"
  appMargin="0"
  appPadding="0"
>
  <div
    class="ui segment"
    *ngFor="let director of companyDirectors; let i = index"
    appMargin
    marginB="3"
    fxLayout="row"
    fxLayoutGap="10px"
    style="align-items: center !important"
  >
    <div fxFlex="5%" *ngIf="isEdit">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="7%">
      <div fxLayout="row">
        <div fxFlex>
          <img
            *ngIf="director.photographDocumentPath"
            src="{{ baseUrl }}/public/image/?media={{
              director?.photographDocumentPath
            }}"
            class="ui mini image image-large"
          />
          <img
            *ngIf="!director.photographDocumentPath"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>
    </div>
    <div fxFlex="15%">{{ director?.firstName }}</div>
    <div fxFlex="15%">{{ director?.lastName }}</div>
    <div fxFlex="15%">
      {{ director?.dateCreated | date: "d, MMMM y,h:mm a" }}
    </div>
    <div fxFlex="10%">{{ director?.createdBy | createdBy }}</div>

    <div *ngIf="affiliateTypeId === 'shareholder_type'" fxFlex="13%">
      {{
        director?.companyName && director?.companyRegNumber
          ? "Company"
          : "Individual"
      }}
    </div>
    <div *ngIf="affiliateTypeId === 'shareholder_type'" fxFlex="7%">
      {{ director?.shareholding }}%
    </div>
    <div
      *ngIf="affiliateTypeId !== 'shareholder_type'"
      fxFlex="15%"
      class="text-right"
    ></div>
    <div fxFlex="10%" class="text-right">
      <ng-container *ngIf="isEdit">
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'remove' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Delete"
          (click)="deleteItem(director, i)"
        >
          <i class="trash icon"></i>
        </button>
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'edit' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Edit"
          (click)="edit(director, i)"
        >
          <i class="pencil icon"></i></button
      ></ng-container>
      <ng-container *ngIf="(!isEdit && !isPending) || isPending">
        <button
          *isPermitted="{ id: 'SHAREHOLDERS_MANAGEMENT', action: 'read' }"
          class="ui circular tiny button"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="View"
          (click)="directorRecord(director)"
        >
          <i class="eye icon"></i></button
      ></ng-container>
    </div>
  </div>
  <app-no-record-found
    *ngIf="companyDirectors && companyDirectors.length < 1"
  ></app-no-record-found>
</div>

<div class="ui vertical basic segment">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <div class="ui labeled button">
        <div class="ui tiny icon button" (click)="getPage(1)">
          <i class="refresh icon"></i>
        </div>
        <a class="ui basic label"> {{ totalItems }} Record(s) </a>
      </div>
    </div>
    <div class="column right aligned pagination menu" style="margin-left: auto">
      <sui-pagination
        class="mini"
        [collectionSize]="totalItems"
        [pageSize]="rows"
        [maxSize]="maxSize"
        [hasEllipses]="false"
        [page]="currentPage"
        (pageChange)="nextPage($event)"
      >
      </sui-pagination>
    </div>
  </div>
</div>
